"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var resolveStoreProps = function resolveStoreProps(state, path) {
  var paths = path.split('.');
  var current = state;
  var i;

  for (i = 0; i < paths.length; ++i) {
    if (current[paths[i]] === undefined) {
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
};

var _default = resolveStoreProps;
exports["default"] = _default;